import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subject } from 'rxjs';
import { ProfilerService } from './profiler-service';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';

@Injectable({ providedIn: 'root' })
export class RenderTrackerService {
  private routeStart = 0;
  private renderDone$ = new Subject<void>();

  constructor(
    router: Router,
    private profilerService: ProfilerService,
    private genDataRepo: GeneralDataRepository
  ) {
    this.genDataRepo.allGeneralData$.subscribe((x) => {
      if (x.activeUserData.isPerformanceTrackingEnabled) {
        router.events.subscribe((event) => {
          if (event instanceof NavigationStart) {
            this.routeStart = performance.now();
          }
        });

        this.renderDone$.subscribe(() => {
          const duration = performance.now() - this.routeStart;

          profilerService.profilesFront.push({
            frontType: '[RenderTracker]',
            frontActionName: router.url,
            frontAction: 'fully rendered',
            duration: duration.toFixed(2),
          });
        });
      }
    });
  }

  notifyRendered(): void {
    this.renderDone$.next();
  }
}

export function whenRendered(callback: () => void): void {
  requestAnimationFrame(() => setTimeout(callback, 0));
}
